import React, { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadingPage from "./components/LoadingPage/LoadingPage";
import { useAppDispatch } from "./store/reduxHooks";
import { UP_DATE_PROFILE } from "./store/slices/profileSlice/profileSlice";
import { PageLayoutLogin, PageLogin } from "./views/indexPage";
import { UP_DATE_ROUTING } from "./store/slices/routingSlice/routingSlice";
import {
  UP_DATE_APPLICATIONS_ALL,
  UP_DATE_APPLICATIONS_TYPE_BG,
} from "./store/slices/applicationBankListSlice/applicationBankListSlice";
import {
  LOADING_PAGE,
  TypeInitialState,
  UP_DATE_BANK_STATUSES,
} from "./store/slices/authSlice/authSlice";
import { UP_DATE_NOTIFICATIONS_ALL } from "./store/slices/notificationsSlice/notificationsSlice";
import { AppRoutes } from "./routes/AppRoutes";

const App: React.FC = () => {
  const isAuthenticated = useSelector(
    (state: { authSlice: TypeInitialState }) => state.authSlice
  );
  // const fiber = useFiber();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // переключение страниц при входе
  useEffect(() => {
    if (isAuthenticated.LoadingPage === "PREV_COMPLICATED") {
      navigate("/");
      const timer = setTimeout(() => {
        navigate("/");
        dispatch(LOADING_PAGE("COMPLICATED"));
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [dispatch, isAuthenticated.LoadingPage, navigate]);

  // запись данных с permission
  useEffect(() => {
    if (isAuthenticated.LoadingPage === "COMPLICATED") {
      if (isAuthenticated.data) {
        Object.keys(isAuthenticated.data).map((data_item) => {
          if (data_item === "routes") {
            const ROUTES = isAuthenticated.data[`${data_item}`];
            if (ROUTES !== undefined) {
              dispatch(UP_DATE_ROUTING(ROUTES));
            }
          }
          if (data_item === "user") {
            const PROFILE = isAuthenticated.data[`${data_item}`];
            if (PROFILE !== undefined) {
              dispatch(UP_DATE_PROFILE(PROFILE));
            }
          }
          if (data_item === "applicationBanks") {
            const APPLICATIONS = isAuthenticated.data[`${data_item}`];
            if (APPLICATIONS !== undefined) {
              dispatch(UP_DATE_APPLICATIONS_ALL(APPLICATIONS));
            }
          }
          if (data_item === "type_bg_list") {
            const LIST_TYPE_BG = isAuthenticated.data[`${data_item}`];
            if (LIST_TYPE_BG !== undefined) {
              dispatch(UP_DATE_APPLICATIONS_TYPE_BG(LIST_TYPE_BG));
            }
          }
          if (data_item === "bank_statuses") {
            const BANK_STATUSES = isAuthenticated.data[`${data_item}`];
            if (BANK_STATUSES !== undefined) {
              dispatch(UP_DATE_BANK_STATUSES(BANK_STATUSES));
            }
          }
          if (data_item === "alerts") {
            const ALERTS = isAuthenticated.data[`${data_item}`];
            if (ALERTS !== undefined) {
              dispatch(UP_DATE_NOTIFICATIONS_ALL(ALERTS));
            }
          }
        });
      }
    }
  }, [dispatch, isAuthenticated.LoadingPage, isAuthenticated.data]);

  if (isAuthenticated.LoadingPage === "COMPLICATED") {
    return <AppRoutes />;
  }
  if (
    isAuthenticated.LoadingPage === "LOADING" ||
    isAuthenticated.LoadingPage === "PREV_COMPLICATED"
  ) {
    return (
      <>
        <LoadingPage />
      </>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<PageLayoutLogin />}>
        <Route path="/login" element={<PageLogin />} />
        <Route index element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Route>
    </Routes>
  );
};

export default App;
